<template>
  <div class="row" id="instructorsContainer">
    <!-- حالة التحميل -->
    <div
      v-if="isLoading"
      class="d-flex justify-content-center align-items-center w-100 my-5"
    >
      <div class="spinner-border text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <!-- حالة عدم وجود مدربين -->
    <div v-if="instructors.length === 0 && !isLoading" class="col-12">
      <div class="no-instructors">
        <b>لا يوجد مدربين حالياً</b><br />
        <i class="mdi mdi-account-off-outline"></i>
      </div>
    </div>

    <!-- عرض المدربين -->
    <div
      v-for="instructor in instructors"
      :key="instructor.id"
      class="col-xl-3 col-lg-4 col-md-6 col-sm-12 mb-4"
    >
      <div class="card instructor-card shadow-sm h-100">
        <div class="card-body text-center">
          <div class="instructor-img-wrapper mb-3">
            <img
              class="rounded-circle instructor-img"
              :src="instructor.user_img"
              alt="Instructor"
              @error="setDefaultImage"
            />
          </div>
          <h5 class="text-success">{{ instructor.name }}</h5>
          <div class="text-muted small mb-2">
            <i class="fa fa-check-circle text-success"></i> منصة أكاديميا
          </div>
          <!-- 5 نجوم -->
          <div class="stars mb-2">
            <i class="fas fa-star text-warning" v-for="n in 5" :key="n"></i>
          </div>
          <a
            class="btn btn-outline-success btn-sm mt-2"
            :href="`instructor-profile?id=${instructor.id}`"
          >
            مشاهدة التفاصيل
          </a>
        </div>
      </div>
    </div>

    <!-- الباجينيشن -->
    <div v-if="pagination.links && pagination.links.length" class="col-12 mt-4">
      <nav>
        <ul class="pagination justify-content-center">
          <!-- Previous -->
          <li
            class="page-item"
            :class="{ disabled: !pagination.prev }"
            @click="changePage(pagination.prev)"
          >
            <a class="page-link" href="#">السابق</a>
          </li>

          <!-- Pages -->
          <li
            v-for="link in pagination.links"
            :key="link?.label || Math.random()"
            class="page-item"
            :class="{ active: link?.active, disabled: !link?.url }"
            v-if="link && (Number(link.label) || link.active)"
            @click="link?.url && changePage(link.url)"
          >
            <a class="page-link" href="#">{{ link.label }}</a>
          </li>

          <!-- Next -->
          <li
            class="page-item"
            :class="{ disabled: !pagination.next }"
            @click="changePage(pagination.next)"
          >
            <a class="page-link" href="#">التالي</a>
          </li>
        </ul>
        <!-- توضيح الصفحة الحالية -->
        <div class="text-center mt-2">
          صفحة {{ meta.current_page }} من {{ meta.last_page }}
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import { apiUrl } from "@/utils/api";

export default {
  data() {
    return {
      instructors: [],
      defaultImage: "/assets/img/acad-icon.png",

      isLoading: false,
      pagination: {
        links: [],
        prev: null,
        next: null,
      },
      meta: {
        current_page: 1,
        last_page: 1,
      },
    };
  },
  mounted() {
    this.getInstructors(`${apiUrl}/instructors-v2`);
  },
  methods: {
    setDefaultImage(event) {
      event.target.src = this.defaultImage;
    },
    async getInstructors(url) {
      try {
        this.isLoading = true;
        const res = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
          },
        });
        const data = await res.json();

        this.instructors = data.data;

        // تحويل الروابط إلى https
        const convertToHttps = (link) => (link ? link.replace(/^http:/, "https:") : null);

        this.pagination.links = data.meta.links.map((linkObj) => ({
          ...linkObj,
          url: convertToHttps(linkObj.url),
        }));

        this.pagination.prev = apiUrl + "/instructors-v2" + data.links.prev;
        this.pagination.next = apiUrl + "/instructors-v2" + data.links.next;

        this.meta = {
          current_page: data.meta.current_page,
          last_page: data.meta.last_page,
        };
      } catch (err) {
        console.error("حدث خطأ أثناء جلب المدربين", err);
      } finally {
        this.isLoading = false;
      }
    },

    changePage(url) {
      if (!url) return;
      this.getInstructors(url);
    },
  },
};
</script>

<style scoped>
.instructor-card {
  transition: transform 0.3s, box-shadow 0.3s;
  border-radius: 20px;
}
.instructor-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
}

.instructor-img-wrapper {
  width: 120px;
  height: 120px;
  margin: 0 auto;
  overflow: hidden;
}

.instructor-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 4px solid #28a745;
  padding: 2px;
}

.stars i {
  margin: 0 2px;
  font-size: 16px;
}

.no-instructors {
  border-radius: 20px;
  padding: 30px;
  color: #000;
  background: #ffceaa;
  margin: 20px;
  text-align: center;
  font-size: 20px;
}
.no-instructors i {
  font-size: 80px;
  margin-top: 10px;
}
</style>
